<template>
  <div class='main'>
    <div class='fr jc ac'>
      <div style='color:#e90001;font-size:30px;font-weight: bold;margin-top: 50px;'>遗体及器官捐献</div>
    </div>

    <div class='mt50' style='font-weight: bold;'>真实姓名</div>

    <input
      v-model='submit_form.name'
      class='mt10'
      type='text'
      placeholder='请输入您的真实姓名'
      style='width: 100%;height: 25px;padding: 4px;border-radius: 2px;'
    />

    <div class='mt50' style='font-weight: bold;'>手机号</div>

    <input
      v-model='submit_form.mobile'
      class='mt10'
      type='text'
      placeholder='请输入您的手机号码'
      style='width: 100%;height: 25px;padding: 4px;border-radius: 2px'
    />

    <div class='mt50' style='font-weight: bold;'>所属街道/镇</div>

    <div>
      <div
        @click='address_show=true'
        class='mt10 fr jc ac'
        style='border-color:white;border-radius: 3px; padding: 4px;   border: 1px solid #dcdfe6;background-color: #fff;'
      >{{submit_form.address}}</div>
    </div>

    <van-popup v-model='address_show' position='bottom'>
      <van-picker
        show-toolbar
        :columns='address_list'
        @cancel='address_show = false'
        @confirm='confirmAddress'
      ></van-picker>
    </van-popup>

    <van-button class='mt50' type='danger' block @click='submit'>提交</van-button>
  </div>
</template>

<script>
import { Toast } from "vant";
export default {
  name: "home",
  data() {
    return {
      submit_form: {
        contribute_type: 2,
        contribute_name: "遗体及器官捐献",
        name: "",
        mobile: "",
        address: "请选择"
      },
      address_show: false,
      address_list: [
        "请选择",
        "吴淞街道",
        "友谊路街道",
        "罗店镇",
        "大场镇",
        "杨行镇",
        "月浦镇",
        "罗泾镇",
        "顾村镇",
        "高境镇",
        "庙行镇",
        "淞南镇",
        "宝山工业区",
        "城市工业园区"
      ]
    };
  },
  methods: {
    //提交
    submit() {
      if (!this.submit_form.name) {
        Toast("请输入名字");
        return;
      }

      if (!this.submit_form.name) {
        Toast("请输入手机号");
        return;
      }

      if (this.submit_form.name == "请选择") {
        Toast("请选择地址");
        return;
      }
      this.post("contribute/add", this.submit_form).then(res => {
        this.$router.push({
          path: "/cornealDonation/applySucess"
        });
      });
    },
    toZxgxb() {
      this.$router.push({
        path: "zxgxb"
      });
    },
    toJxxz() {
      this.$router.push({
        path: "jxxz"
      });
    },
    toCjd() {
      this.$router.push({
        path: "cjd"
      });
    },
    toJxlc() {
      this.$router.push({
        path: "jxlc"
      });
    },
    //确认地址
    confirmAddress(item) {
      this.submit_form.address = item;
      this.address_show = false;
    },
    toSignUp() {
      window.open("http://np-culture.org/event/sh-blood/redcross/");
    }
  },
  components: {},
  mounted() {}
};
</script>


<style lang="less" scoped>
.main {
  box-sizing: border-box;
  padding: 30px;
  width: 100vw;
  height: 100vh;
  background-image: url("./../../assets/index/bg.png");
  background-size: cover;
}

.grid {
  margin-top: 38px;
  display: flex;
  .item {
    width: 143px;
    height: 143px;
  }
  .left {
    display: flex;
    flex-direction: column;
  }
  .right {
    display: flex;
    flex-direction: column;
  }
}
</style>